import { Injectable } from '@angular/core';
import { AAAStore } from '../../store/root-reducer';
import { select, Store } from '@ngrx/store';
import { selectUserSessionId } from '../../modules/session/session.selectors';

@Injectable({
  providedIn: 'root',
})
export class DynatraceService {

  constructor(private store$: Store<AAAStore>) {
    this.store$.pipe(select(selectUserSessionId)).subscribe((sessionId) => this.setUserSessionData(sessionId));
  }

  private setUserSessionData(userSessionId: string) {
    if (typeof window !== 'undefined' && (window as any).dtrum) {
      (window as any).dtrum.identifyUser(userSessionId);
    }
  }
}
